import { plugin, debug, type ColorProps } from 'light-component';
import { ColorPicker } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function WidgetColorPicker(props: ColorProps): ReactElement {
  debug.widget('dashboard colorPicker', props);
  if (props.mode === 'thumbnail') {
    return (<ThumbnailColorPicker {...props} />);
  }
  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <div>
        <ColorPicker
          className={styles.colorPicker}
          showText
          allowClear
          defaultValue='#ffffff'
          value={props.value}
          onChange={color => props.onChange?.(color.toHexString())}
        />
      </div>
    </div>
  );
}

function ThumbnailColorPicker(props: ColorProps): ReactElement {
  return (
    <div className={styles.control} {...props}>
      <Icons name='AppstoreAddOutlined' className={styles.icon} />
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'color', component: WidgetColorPicker });
